import * as api from '../api';
import { getIsFetching } from '../reducers/otherPestsRef';

export const FETCH_ZONES_CHOICE = 'intervention.FETCH_ZONES_CHOICE';
export const FETCH_ZONES_CHOICE_SUCCESS =
  'intervention.FETCH_ZONES_CHOICE_SUCCESS';

export const FETCH_ZONE_TEMPLATES = 'intervention.FETCH_ZONE_TEMPLATES';
export const FETCH_ZONE_TEMPLATES_SUCCESS =
  'intervention.FETCH_ZONE_TEMPLATES_SUCCESS';

const requestZonesChoice = () => ({
  type: FETCH_ZONES_CHOICE,
});

const receiveZonesChoice = choices => ({
  type: FETCH_ZONES_CHOICE_SUCCESS,
  choices,
});

export const fetchZoneChoices = intervention => (dispatch, getState) => {
  const state = getState();
  if (getIsFetching(state)) {
    return Promise.resolve();
  }

  dispatch(requestZonesChoice());

  return api
    .getZoneCopyChoice(intervention)
    .then(response => dispatch(receiveZonesChoice(response)));
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/actions/zonesRef.js